<template>
  <div>
    <div
      v-for="quota in quotas"
      :key="quota.key"
      class="quota-row d-flex align-center flex-wrap ga-3 px-4 py-2"
      :class="{
        'recently-changed': recentKey === `quota:${quota.key}`,
      }"
    >
      <!-- Menu/button-less mutations (reset) carry their spinner on this bar. -->
      <v-progress-linear
        v-if="pendingKey === `quota:${quota.key}`"
        class="quota-row-progress"
        indeterminate
        color="primary"
      />
      <div class="quota-main d-flex align-center flex-wrap ga-2 flex-grow-1">
        <span class="text-body-2">{{ quota.description }}</span>
        <span
          v-if="metaLine(quota)"
          class="text-caption text-medium-emphasis"
        >
          {{ metaLine(quota) }}
        </span>
      </div>

      <div class="d-flex align-center ga-3 flex-shrink-0">
        <span class="text-body-1 font-weight-medium">
          {{ formatFlagValue(quota.limit) }}
        </span>
        <v-chip
          size="small"
          variant="text"
          :class="['px-1', quota.is_overridden ? '' : 'text-medium-emphasis']"
          :color="quota.is_overridden ? 'primary' : undefined"
        >
          {{ quota.is_overridden ? "Personalizado" : "Padrão" }}
        </v-chip>

        <template v-if="canUpdate">
          <v-btn
            size="small"
            color="primary"
            variant="tonal"
            :disabled="!!pendingKey"
            @click="$emit('edit', quota)"
          >
            Editar
          </v-btn>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatFlagValue } from "./entitlementDisplay";

defineProps({
  quotas: { type: Array, required: true },
  pendingKey: { type: String, default: null },
  recentKey: { type: String, default: null },
  canUpdate: { type: Boolean, default: false },
});

defineEmits(["edit"]);

// When overridden, surface the registry default beside it so the operator sees
// what they're deviating from.
const metaLine = (quota) => {
  const parts = [];
  if (quota.is_overridden) {
    parts.push(`padrão ${formatFlagValue(quota.default)}`);
  }
  return parts.join(" · ");
};
</script>

<style scoped>
.quota-row {
  position: relative;
  /* Match the feature rows' uniform single-line height. */
  min-height: 44px;
}

.quota-row + .quota-row {
  border-top: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.quota-row-progress {
  position: absolute;
  top: 0;
  left: 0;
}

.quota-main {
  flex-basis: 260px;
  min-width: 260px;
}

.quota-row.recently-changed {
  animation: entitlement-row-flash 1.6s ease-out;
}

@keyframes entitlement-row-flash {
  from {
    background-color: rgba(var(--v-theme-primary), 0.12);
  }
  to {
    background-color: transparent;
  }
}
</style>
